export const adminNavigations = [
  {
    icon: 'mdi-view-dashboard',
    title: 'dashboard',
    to: '/dashboard',
    open: false,
    permissions: 'Idn'
  },
  {
    icon: 'mdi-account',
    title: 'users',
    to: '/users',
    open: false,
    permissions: ['user-management.users']
  },
  {
    icon: 'mdi-security',
    title: 'roles',
    to: '/roles',
    open: false,
    permissions: ['identity.roles']
  },
  {
    icon: 'mdi-devices',
    title: 'devices',
    to: '/devices',
    open: false,
    permissions: ['hooshmandteb.device']
  },
]

export const userNavigations = [
  {
    icon: 'mdi-view-dashboard',
    title: 'dashboard',
    to: '/my-dashboard',
    open: false,
    consular: false,
    permissions: 'Idn'
  },
  {
    icon: 'mdi-devices',
    title: 'myDevices',
    to: '/my-devices',
    open: false,
    consular: true,
    permissions: 'Idn'
  },
  {
    icon: 'mdi-doctor',
    title: 'myConsulars',
    to: '/my-consulars',
    open: false,
    consular: false,
    permissions: 'Idn'
  }
]
